import _ from "lodash";
import { Types } from "./workforceActions";



const workforceReducers = (state, action) => {
    switch (action.type) {
        case Types.WORKFORCE_IMPORT_TIMESHEETS: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance.tanda.importingTimesheets = action.status ? action.status : undefined

            return newState;
        }
        case Types.WORKFORCE_IMPORT_LEAVE: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance.tanda.importingLeave = action.status ? action.status : undefined

            return newState;
        }
        case Types.WORKFORCE_EMPLOYEE_LINKS: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance.tanda.links = action.links ? action.links : undefined
            newState.integration.timeAttendance.tanda.employees = action.employees ? action.employees : undefined

            return newState;
        }
        case Types.WORKFORCE_TEAMS: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance.tanda.teams = action.teams ? action.teams : undefined
            newState.integration.timeAttendance.tanda.locations = action.locations ? action.locations : undefined

            return newState;
        }
        case Types.WORKFORCE_SET_TEAMS: {

            let newState = _.cloneDeep(state);

            const { teams, agreement } = action

            // find agreement in links and update teams
            const links = newState.integration.timeAttendance.tanda.links
            const agreementIndex = links.findIndex((link) => link.agreement == agreement)
            if (agreementIndex > -1) {
                links[agreementIndex].teams = teams
            }

            return newState;
        }
        case Types.WORKFORCE_AUTO_MAP_RESULT: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance.tanda.employeesNotFound = action.result ? action.result : undefined

            return newState;
        }

        case Types.WORKFORCE_AUTO_MAP_LOADING: {
            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance.tanda.autoMapLoading = action.status ? action.status : undefined

            return newState;
        }

        default:
            return state;
    }
};

export default workforceReducers;